/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Button, Dialog } from '@radix-ui/themes';

import { use } from 'fierry/react';

import Galaxy from 'solis/application/galaxy';

import Login from 'solis/auth/login';

import { OFFLINE } from 'solis/auth';
import { getUpgradeConfig } from 'solis/auth/firebase';


export default () =>
{
  const galaxy = use(Galaxy);

  const account = galaxy.getCurrentAccount();

  if (OFFLINE || !account.cass.anonymous)
  {
    return null;
  }

  return (
    <Dialog.Root>
      <Dialog.Trigger>
        <Button variant = 'soft'>Link account</Button>
      </Dialog.Trigger>

      <Dialog.Content size = '2' maxWidth = '400px'>
        <Dialog.Title>Link account</Dialog.Title>
        <Dialog.Description size = '2' color = 'gray'>
          Keep your progress by linking your guest account.
        </Dialog.Description>

        <Login config = {getUpgradeConfig()} />
      </Dialog.Content>
    </Dialog.Root>
  );
};
